import {
    SET_COPY_OF_MANUAL_CASH_LIMIT_DATA,
    REMOVE_COPY_OF_MANUAL_CASH_LIMIT_DATA,
} from '../actions/copyOfManualCashLimit';

const copyOfManualCashLimit = (state = null, action = undefined) => {
    switch (action.type) {
        case SET_COPY_OF_MANUAL_CASH_LIMIT_DATA:
            return {
                ...action.payload,
            };
        case REMOVE_COPY_OF_MANUAL_CASH_LIMIT_DATA:
            return null;
        default:
            return state;
    }
};

export default copyOfManualCashLimit;
